import { useState } from "react";
import { Route, Routes } from "react-router-dom";

import { MobileHeading } from "features/layout/components";
import { ManageSubscriptionDialog } from "features/subscriptions/components";
import { PRICING_PLANS } from "features/subscriptions/constants";
import useSubscriptions from "features/subscriptions/hooks/useSubscriptions";

import ActivatePlanLayout from "../ActivatePlanLayout";
import Invoices from "../Invoices";
import PlanInvoicesToggle from "../PlanInvoicesToggle";
import SettingsScrollContent from "../SettingsScrollContent";
import PlanDetails from "./PlanDetails";

export default function AgencyPlan() {
  const [isManageOpen, setIsManageOpen] = useState(false);
  const { agency } = useSubscriptions();

  const showGetAgencyPlan =
    !agency || agency.subscription.status === "cancelled";

  const actionComponent = agency?.subscription && (
    <PlanInvoicesToggle planLabel={PRICING_PLANS.agency.name} />
  );

  return (
    <>
      <SettingsScrollContent desktopActionComponent={actionComponent}>
        {actionComponent && <MobileHeading actionComponent={actionComponent} />}
        <Routes>
          <Route
            path=""
            element={
              showGetAgencyPlan ? (
                <ActivatePlanLayout
                  plan="agency"
                  onActivate={() => setIsManageOpen(true)}
                />
              ) : (
                <PlanDetails
                  onManageSubscription={() => setIsManageOpen(true)}
                />
              )
            }
          />
          <Route path="invoices" element={<Invoices type="agency" />} />
        </Routes>
      </SettingsScrollContent>

      <ManageSubscriptionDialog
        initialState={agency || "agency"}
        isOpen={isManageOpen}
        setIsOpen={setIsManageOpen}
        mixpanelSource="billing_page"
      />
    </>
  );
}
